import styled from 'styled-components';

const TransactionsDetailsContainerStyled = styled.div`
  margin-top: 20px;
  width: calc(100% - 20px);
`;

export default TransactionsDetailsContainerStyled;
